import { Helmet } from "react-helmet-async";
import { Layout } from "../../components/layout";
import {
  MyButton,
  CustomModal,
  Dropdown,
  Input,
  LoadingSpinner,
  Pagination,
  EmptyTable,
  ActiveFilters,
} from "../../components";
import { BsList, BsThreeDotsVertical } from "react-icons/bs";
import { IoIosAdd } from "react-icons/io";
import {
  Menu,
  MenuItem,
  Box,
  Tabs,
  Tab,
  Select,
  IconButton,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FaFilter } from "react-icons/fa6";
import { LeadDataController } from "../../controllers";
import { Cancel } from "../../../assets";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import DatePicker from "react-multi-date-picker";
import persian_fa from "react-date-object/locales/persian_fa";
import persian from "react-date-object/calendars/persian";
import { FaAngleDown, FaRegCalendarAlt } from "react-icons/fa";
function CustomInput({
  onFocus,
  value,
  onChange,
  title,
  emptyState,
  error,
}: any) {
  return (
    <Input
      emptyState={emptyState}
      hideEndAdornment
      type="number"
      error={error}
      onChange={onChange}
      customFocus={onFocus}
      myStyle="w-100"
      title={title}
      value={value}
    />
  );
}
// normalize a backend field into a readable display value (primitive or { value })
function fieldValue(field: any): string {
  if (field === null || field === undefined) return "";
  if (typeof field === "object") {
    if (field && "value" in field) return field.value ?? "";
    return "";
  }
  return String(field);
}

// prefer a field's own title, otherwise fall back to its key
function fieldTitle(field: any, fallback: string): string {
  if (field && typeof field === "object" && field.title) return field.title;
  return fallback;
}

// categorize a lead add-form field so related fields can be grouped into rows
function categorizeLeadField(key: string, field: any): string {
  const h = `${key} ${fieldTitle(field, key)}`.toLowerCase();
  if (/email|ایمیل/.test(h)) return "email";
  if (/phone|mobile|تلفن|موبایل|همراه/.test(h)) return "phone";
  if (/address|آدرس|نشانی/.test(h)) return "address";
  if (/postal|کد پستی|پستی/.test(h)) return "postal";
  if (/national|melli|shenase|شناسه ملی|کد ملی/.test(h)) return "national";
  if (/description|توضیح|شرح/.test(h)) return "description";
  if (/employee|staff|کارکنان|کارمند/.test(h)) return "employees";
  if (/company|نام شرکت|شرکت/.test(h)) return "company";
  return "other";
}

class LeadData extends LeadDataController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getLeadsDataList();
  }
  render() {
    const {
      leadsDataList,
      loading,
      count,
      page,
      openEditModal,
      member,
      to_date,
      from_date,
      membersList,
      openShowMoreModal,
      details,
      rowsCountList,
      newInfo,
      addInfo,
      state,
      errorsList,
      openAddModal,
      openModal,
      statesList,
      step,
    } = this.state;
    function a11yProps(index: number) {
      return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
      };
    }
    return (
      <>
        <Layout title="سرنخ‌ها">
          <Helmet>
            <title> سرنخ‌ها | سامانه مشتریان</title>
          </Helmet>
          <div className="users-list">
            {loading ? (
              <LoadingSpinner />
            ) : (
              <>
                <>
                  <div className="users-list-headline mt-3">
                    <div className="">
                      <BsList color="#003366" className="ms-2" />{" "}
                      <span className="title">سرنخ‌ها</span>
                    </div>
                    <div className="headline-btn-group d-flex ">
                      <MyButton
                        myStyle="yellow"
                        icon={<FaFilter className="ms-2" />}
                        title=" فیلترها"
                        onClick={() => this.handleOpenModal()}
                      />
                      <MyButton
                        myStyle="add"
                        icon={<IoIosAdd className="ms-2" />}
                        title="افزودن سرنخ"
                        onClick={() => this.handleOpenAdd()}
                      />
                    </div>
                  </div>
                  {/* ---------- Active Filters ---------- */}
                  {this.hasActiveFilter() && (
                    <ActiveFilters filters={this.getActiveFiltersList()} />
                  )}
                  <div className="users-list-container">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>ردیف</TableCell>
                          <TableCell>اطلاعات</TableCell>
                          <TableCell>کاربر </TableCell>
                          <TableCell>تاریخ ارجاع</TableCell>
                          <TableCell>وضعیت </TableCell>
                          <TableCell>عملیات</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {!leadsDataList?.list?.length && <EmptyTable />}
                        {leadsDataList?.list?.map(
                          (item: any, index: number) => {
                            return (
                              <>
                                <TableRow
                                  key={index}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {index + 1}
                                  </TableCell>
                                  <TableCell>{item?.brif || "--"}</TableCell>
                                  <TableCell>{item?.user || "--"}</TableCell>
                                  <TableCell>
                                    {item?.asign_date || "--"}
                                  </TableCell>
                                  <TableCell>
                                    {item?.state_title || "--"}
                                  </TableCell>
                                  <TableCell>
                                    <PopupState
                                      variant="popover"
                                      popupId="demo-popup-menu"
                                    >
                                      {(popupState: any) => (
                                        <>
                                        <IconButton
                                          sx={{
                                            color: "#0c1a58",
                                            padding: "4px"
                                          }}
                                          {...bindTrigger(popupState)}
                                        >
                                          <BsThreeDotsVertical />
                                        </IconButton>
                                          {/* <Button
                                            sx={{
                                              background: "#D4AF37",
                                              ":hover": {
                                                bgcolor: "#D4AF37",
                                              },
                                            }}
                                            variant="contained"
                                            {...bindTrigger(popupState)}
                                          >
                                            عملیات
                                          </Button> */}
                                          <Menu {...bindMenu(popupState)}>
                                            {item?.ticket_id && (
                                              <MenuItem
                                                onClick={() =>
                                                  window.open(
                                                    `/details-ticket/${item?.ticket_id}`,
                                                    "_blank"
                                                  )
                                                }
                                              >
                                                رفتن به تیکت
                                              </MenuItem>
                                            )}
                                            <MenuItem
                                              onClick={() =>
                                                this.handleChangeState(item)
                                              }
                                            >
                                              تغییر وضعیت
                                            </MenuItem>
                                            <MenuItem
                                              onClick={() =>
                                                this.handleShowMore(item)
                                              }
                                            >
                                              اطلاعات بیشتر
                                            </MenuItem>
                                          </Menu>
                                        </>
                                      )}
                                    </PopupState>
                                  </TableCell>
                                </TableRow>
                              </>
                            );
                          }
                        )}
                      </TableBody>
                    </Table>
                    <Pagination
                      count={leadsDataList?.pages ? leadsDataList?.pages : 1}
                      page={page}
                      total={leadsDataList?.total}
                      pageNumber={leadsDataList?.page_number}
                      onChangePage={this.handleChangePage}
                      rowsCountList={rowsCountList}
                      countValue={count}
                      onChangeCount={(value: any) => this.handleCount(value)}
                    />
                  </div>
                </>
                <CustomModal
                  myStyle="users-list-filter-modal"
                  openModal={openModal}
                  onClose={() => this.closeModal()}
                >
                  <>
                    <div className="custom-modal-main-title mb-2">
                      <h1 className="custom-modal-title">فیلترها</h1>
                      <Cancel
                        myStyle="ps-2 cursor-pointer"
                        color="#000000"
                        onClick={() => this.closeModal()}
                      />
                    </div>
                    <div className="custom-modal-content">
                    <div className="custom-modal-row ">
                      <Dropdown
                        placeholder="یک گزینه را انتخاب کنید"
                        items={membersList}
                        objectList
                        myStyle=" w-100"
                        title="اعضا"
                        value={member}
                        onChange={(e: any) => this.handleMemberChange(e)}
                        emptyState={() => this.setState({ member: "" })}
                      >
                        {membersList &&
                          membersList?.map((item: any, index: number) => {
                            return (
                              <MenuItem value={item?.id} key={index}>
                                {item?.title}
                              </MenuItem>
                            );
                          })}
                      </Dropdown>
                    </div>
                    <div className="custom-modal-row cols-2">
                      <DatePicker
                        ref={this.datePickerRef}
                        render={
                          <CustomInput
                            title="از تاریخ"
                            emptyState={() => this.emptyFromDate()}
                          />
                        }
                        value={from_date}
                        dateSeparator=" تا "
                        calendar={persian}
                        locale={persian_fa}
                        placeholder=" از تاریخ "
                        containerClassName="custom-modal-item-w-50 filter-date-container"
                        inputClass="custom-date-input"
                        calendarPosition="top-right"
                        onChange={this.handleChangeFromDate}
                      />
                      <DatePicker
                        ref={this.datePickerRef}
                        render={
                          <CustomInput
                            title="تا تاریخ"
                            emptyState={() => this.emptyToDate()}
                          />
                        }
                        dateSeparator=" تا "
                        calendar={persian}
                        locale={persian_fa}
                        value={to_date}
                        calendarPosition="top-right"
                        placeholder="تا تاریخ"
                        containerClassName="custom-modal-item-w-50 filter-date-container"
                        inputClass="custom-date-input"
                        onChange={this.handleChangeToDate}
                      />
                    </div>
                    <div className="custom-modal-row mb-57">
                      <Dropdown
                        placeholder="یک گزینه را انتخاب کنید"
                        items={statesList}
                        objectList
                        myStyle=" w-100"
                        title="وضعیت"
                        value={state}
                        onChange={(e: any) => this.handleStateFilterChange(e)}
                        emptyState={() => this.setState({ state: "" })}
                      >
                        {statesList &&
                          statesList?.map((item: any, index: number) => {
                            return (
                              <MenuItem value={item?.id} key={index}>
                                {item?.title}
                              </MenuItem>
                            );
                          })}
                      </Dropdown>
                    </div>

                    <div className="custom-modal-confirm">
                      <MyButton
                        myStyle="bg-green"
                        title="اعمال"
                        onClick={() => this.handleApplyFilter()}
                      />
                    </div>
                    </div>
                  </>
                </CustomModal>
                <CustomModal
                  myStyle="one-field-modal"
                  openModal={openEditModal}
                  onClose={() =>
                    this.setState({
                      openEditModal: !openEditModal,
                      state: "",
                      errorsList: [],
                    })
                  }
                >
                  <>
                    <div className="custom-modal-main-title mb-2">
                      <h1 className="custom-modal-title">ویرایش وضعیت</h1>
                      <Cancel
                        myStyle="ps-2 cursor-pointer"
                        color="#000000"
                        onClick={() =>
                          this.setState({
                            openEditModal: !openEditModal,
                            state: "",
                            errorsList: [],
                          })
                        }
                      />
                    </div>
                    <div className="custom-modal-content">
                    <div className="custom-modal-row ">
                      <Dropdown
                        placeholder="یک گزینه را انتخاب کنید"
                        items={statesList}
                        objectList
                        myStyle=" w-100"
                        title="وضعیت"
                        value={state}
                        onChange={(e: any) => {
                          this.setState({ state: e.target.value });
                        }}
                        emptyState={() => this.setState({ state: "" })}
                        error={
                          errorsList.filter(
                            (name: { path: string }) => name.path === "state"
                          )?.[0]?.errors?.[0]
                        }
                      >
                        {statesList &&
                          statesList?.map((item: any, index: number) => {
                            return (
                              <MenuItem value={item?.id} key={index}>
                                {item?.title}
                              </MenuItem>
                            );
                          })}
                      </Dropdown>
                    </div>

                    <div className="custom-modal-confirm">
                      <MyButton
                        myStyle="bg-green"
                        title="اعمال"
                        onClick={() => this.changeState()}
                      />
                    </div>
                    </div>
                  </>
                </CustomModal>
                <CustomModal
                  myStyle="lead-details-modal"
                  openModal={openShowMoreModal}
                  onClose={() =>
                    this.setState({
                      openShowMoreModal: !openShowMoreModal,
                      details: {},
                    })
                  }
                >
                  <>
                    <div className="custom-modal-main-title mb-2">
                      <div>
                        <h1 className="title">اطلاعات بیشتر</h1>
                      </div>
                      <Cancel
                        myStyle="ps-2 "
                        width="20"
                        height="20"
                        color="#000000"
                        onClick={() =>
                          this.setState({
                            openShowMoreModal: !openShowMoreModal,
                            details: {},
                          })
                        }
                      />
                    </div>
                    <div className="custom-modal-content">
                      <Box sx={{ width: "100%" }}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                          <Tabs
                            className="lead-details-tabs"
                            value={step}
                            onChange={(e: any, newValue: number) =>
                              this.handleChangeTab(e, newValue)
                            }
                            variant="fullWidth"
                            aria-label="lead details tabs"
                          >
                            <Tab label="داده اولیه" {...a11yProps(0)} />
                            <Tab label="داده تکمیلی" {...a11yProps(1)} />
                          </Tabs>
                        </Box>

                        {step === 0 && (
                          <div className="lead-info-grid">
                            {details?.data &&
                            Object.keys(details?.data?.prep || {}).length > 0 ? (
                              (() => {
                                const prepFields = Object.keys(
                                  details?.data?.prep
                                ).map((key) => ({
                                  key,
                                  field: details?.data?.prep[key],
                                }));
                                // count-based layout pattern:
                                // 1 box → full width
                                // 2 boxes → each 1/2
                                // 3 boxes → first full width, next two 1/2
                                // 4 boxes → all 1/2
                                // (odd counts always start with a full-width box)
                                const firstIsFull =
                                  prepFields.length % 2 === 1;
                                return prepFields.map(
                                  ({ key, field }, index) => {
                                    const value = fieldValue(field);
                                    return (
                                      <div
                                        className={`lead-info-field${
                                          firstIsFull && index === 0
                                            ? " lead-info-field--full"
                                            : ""
                                        }`}
                                        key={key}
                                      >
                                        <span className="lead-info-label">
                                          {fieldTitle(field, key)}
                                        </span>
                                        <span className="lead-info-value">
                                          {value || "--"}
                                        </span>
                                      </div>
                                    );
                                  }
                                );
                              })()
                            ) : (
                              <div className="lead-info-empty">
                                اطلاعاتی ثبت نشده است
                              </div>
                            )}
                          </div>
                        )}

                        {step === 1 && (
                          <div className="lead-info-grid">
                            {details?.data &&
                            Object.keys(details?.data?.data || {}).length > 0 ? (
                              Object.keys(details?.data?.data).map((key) => {
                                const field = details?.data?.data[key];
                                return (
                                  <div className="lead-info-field" key={key}>
                                    <span className="lead-info-label">
                                      {field?.title || key}
                                    </span>
                                    <span className="lead-info-value">
                                      {field?.value || "--"}
                                    </span>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="lead-info-empty">
                                اطلاعاتی ثبت نشده است
                              </div>
                            )}
                          </div>
                        )}
                      </Box>

                      {Array.isArray(details?.data?.end_policy) &&
                        details?.data?.end_policy.length > 0 && (
                          <div className="lead-end-policy">
                            <div className="lead-end-policy-title">
                              <FaRegCalendarAlt />
                              تاریخ‌های پایان
                            </div>
                            <div className="lead-end-policy-list">
                              {details?.data?.end_policy.map(
                                (item: any, index: number) => (
                                  <div
                                    className="lead-end-policy-item"
                                    key={index}
                                  >
                                    <div className="lead-end-policy-cell">
                                      <span className="lead-end-policy-label">
                                        محصول
                                      </span>
                                      <span className="lead-end-policy-value">
                                        {item?.product_title || "--"}
                                      </span>
                                    </div>
                                    <div className="lead-end-policy-cell">
                                      <span className="lead-end-policy-label">
                                        بیمه
                                      </span>
                                      <span className="lead-end-policy-value">
                                        {item?.insurance_title || "--"}
                                      </span>
                                    </div>
                                    <div className="lead-end-policy-cell">
                                      <span className="lead-end-policy-label">
                                        تاریخ پایان
                                      </span>
                                      <span className="lead-end-policy-value">
                                        {item?.end_date || "--"}
                                      </span>
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        )}
                    </div>
                  </>
                </CustomModal>
                <CustomModal
                  myStyle="users-list-filter-modal"
                  openModal={openAddModal}
                  onClose={() =>
                    this.setState({
                      openAddModal: !openAddModal,
                      addInfo: {},
                      newInfo: {},
                    })
                  }
                >
                  <>
                    <div className="custom-modal-main-title mb-2">
                      <div>
                        <h1 className="title">افزودن سرنخ</h1>
                      </div>
                      <Cancel
                        myStyle="ps-2 "
                        width="20"
                        height="20"
                        color="#000000"
                        onClick={() =>
                          this.setState({
                            openAddModal: !openAddModal,
                            addInfo: {},
                            newInfo: {},
                          })
                        }
                      />
                    </div>
                    <div className="custom-modal-content">
                    <div className="custom-modal-body">
                      {(() => {
                        const addFields = Object.keys(addInfo).map((key) => ({
                          key,
                          field: addInfo[key],
                        }));
                        const byCat = (cat: string) =>
                          addFields.filter(
                            (f) => categorizeLeadField(f.key, f.field) === cat
                          );

                        const renderAddInput = (key: string, field: any) => {
                          if (field?.type === "text_area") {
                            return (
                              <Input
                                rows={3}
                                multiline
                                key={key}
                                name={key}
                                myStyle="custom-modal-item w-100"
                                title={field.title}
                                value={field.value}
                                onChange={(e: any) =>
                                  this.handleAddModalInputsChange(
                                    key,
                                    e.target.value
                                  )
                                }
                              />
                            );
                          }
                          if (field?.type === "int") {
                            return (
                              <Input
                                key={key}
                                type="number"
                                name={key}
                                myStyle="custom-modal-item w-100"
                                title={field.title}
                                value={field.value}
                                onChange={(e: any) =>
                                  this.handleAddModalInputsChange(
                                    key,
                                    e.target.value
                                  )
                                }
                              />
                            );
                          }
                          return (
                            <Input
                              key={key}
                              type="text"
                              name={key}
                              myStyle="custom-modal-item w-100"
                              title={field.title}
                              value={field.value}
                              onChange={(e: any) =>
                                this.handleAddModalInputsChange(
                                  key,
                                  e.target.value
                                )
                              }
                            />
                          );
                        };

                        const rows = [
                          { cols: "cols-2", cats: ["email", "phone"] },
                          { cols: "", cats: ["address"] },
                          { cols: "cols-2", cats: ["postal", "national"] },
                          { cols: "", cats: ["description"] },
                          { cols: "cols-2", cats: ["company", "employees"] },
                        ];

                        const usedKeys = new Set<string>();
                        const grouped = rows.map((row) => {
                          const items: { key: string; field: any }[] = [];
                          row.cats.forEach((cat) => {
                            byCat(cat).forEach((f) => {
                              usedKeys.add(f.key);
                              items.push(f);
                            });
                          });
                          return { cols: row.cols, items };
                        });
                        const others = addFields.filter(
                          (f) => !usedKeys.has(f.key)
                        );

                        return (
                          <>
                            {grouped.map((row, idx) =>
                              row.items.length > 0 ? (
                                <div
                                  className={`custom-modal-row ${row.cols}`.trim()}
                                  key={`lead-row-${idx}`}
                                >
                                  {row.items.map((f) =>
                                    renderAddInput(f.key, f.field)
                                  )}
                                </div>
                              ) : null
                            )}
                            {others.map((f) => (
                              <div
                                className="custom-modal-row"
                                key={`lead-row-other-${f.key}`}
                              >
                                {renderAddInput(f.key, f.field)}
                              </div>
                            ))}
                          </>
                        );
                      })()}
                    </div>
                    <div className="custom-modal-confirm">
                      <MyButton
                        myStyle="bg-green"
                        title="افزودن"
                        onClick={() => this.handleAddLead()}
                      />
                    </div>
                    </div>
                  </>
                </CustomModal>
              </>
            )}
          </div>
        </Layout>
      </>
    );
  }
}
export default LeadData;
